<template>
  <span>
    <!-- <v-date-picker></v-date-picker> -->

    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <TextField
          :value="formattedDate"
          :field="field"
          :valid="valid"
          append-icon="fa-calendar"
          :disabled="disabled"
          v-bind="attrs"
          v-on="on"
          readonly
        ></TextField>
      </template>

      <v-date-picker
        class="ep-datepicker"
        :value="value"
        :min="field.min"
        :disabled="disabled"
        @change="onDateChange"
        no-title
        scrollable
      >
      </v-date-picker>
    </v-menu>
  </span>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";
import TextField from "@/components/fields/TextField.vue";

export default {
  name: "DatePicker",

  props: ["field", "value", "valid", "disabled"],
  components: { TextField },

  data: () => ({
    menu: false
  }),

  mounted() {},
  computed: {
    formattedDate() {
      if (this.value) {
        return moment(this.value).format("MM-DD-YYYY");
      }

      return this.value;
    }
  },
  methods: {
    onDateChange(date) {
      // this.date = date;
      this.$emit("input", date);

      this.$refs.menu.save(date);
    }
  }
};
</script>

<style lang="scss">
.ep-datepicker {
  tr {
    background-color: transparent !important;

    td,
    th {
      width: auto !important;
      border-bottom: transparent !important;
      padding: 0 !important;
    }
  }

  button {
    padding: 0 !important;
    box-shadow: none !important;
    background-color: transparent !important;
  }
}
</style>
